import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../../utils/axios"; 

export const useSuggestions = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data: suggestions } = useQuery({
    queryKey: ["suggestions"],
    queryFn: () => makeRequest.get("/users/suggestions").then((res) => res.data),
  });

  const addFriendMutation = useMutation({
    mutationFn: (userId) => {
      return makeRequest.post("/friendships", { userId });
    },
    onSuccess: (_, userId) => {
      queryClient.setQueryData(["suggestions"], (oldData) => {
        if (!oldData) return [];
        return oldData.filter((user) => user.id !== userId);
      });

      queryClient.invalidateQueries({ queryKey: ["friendship", userId] });
      queryClient.invalidateQueries({ queryKey: ["friendRequests"] });
    },
  });

  return {
    suggestions,
    isLoading,
    error,
    handleAddFriend: addFriendMutation.mutate,
    isPending: addFriendMutation.isPending || addFriendMutation.isLoading,
  };
};